import { useEffect } from 'react';
import clsx from 'clsx';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { UserManagement } from 'components/UserManagement/UserManagement';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useLocale } from 'hooks/useLocale';
import { useNavigate } from 'react-router-dom';
import { getCookie } from 'utils/cookieHelper';
import { getEnvironment } from 'utils/environmentHelper/environmentHelper';
import { PATH_NAMES } from 'utils/routes/pathNames';
import styles from './userManagement.module.css';

export const UserManagementPage = () => {
  const navigate = useNavigate();
  const { isUK } = useLocale();
  const { introducerType } = useIntroducerData();
  const hasAccessToUserManagement =
    isUK &&
    introducerType !== 'partner' &&
    Boolean(getCookie('showUserManagement'));

  useEffect(() => {
    if (!hasAccessToUserManagement) {
      navigate(PATH_NAMES.home());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAccessToUserManagement]);

  if (!hasAccessToUserManagement) return null;

  return (
    <BaseLayout
      pageTitle="User management | Introducer Portal"
      className={clsx(styles.layout, {
        [styles.layoutWithBanner]: getEnvironment() === 'staging',
      })}
    >
      <UserManagement />
    </BaseLayout>
  );
};
